import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TimesheetverificationComponent } from './timesheetverification.component';


const routes: Routes = [
  {
    path: '',
    component: TimesheetverificationComponent,
  
  }

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TimesheetverificationRoutingModule { }
   